import React, { useEffect, useState } from "react";
import { Pill } from "Components";
import colors from "Assets/sass/core/vars.scss";
import moment from "moment";
import { GetFormatForMoment } from "Core/data/Helpers";
import { useSelector } from "react-redux";

export const PillTime = ({ date, setShowSidePanel, showSidePanel }) => {

    const { user } = useSelector((state) => state.securityRedux);
    const { dateformat, timeZone } = user;
    const format = GetFormatForMoment(dateformat);


    const [label, setLabel] = useState('')

    useEffect(() => {
        let buildLabel = ''
        if(date?.option){
            buildLabel = date?.option?.label
        }

        if(date?.start && date?.end){
            buildLabel = `${buildLabel} (${moment(date?.start).format(format)} -  ${moment(date?.end).format(format)})`
        }

        setLabel(buildLabel)
    }, [date])

  return (
    <Pill
      outlined={false}
      textField="label"
      onClick={() => setShowSidePanel(!showSidePanel)}
      style={{ width: 300 }}
      item={{ label: label, color: colors["green"] }}
    />
  );
};
